import {EventEmitter2} from 'eventemitter2'
class BaseView {
  constructor (params) {
    let eventemitter = new this._initEventEmitter()
    this.$on = function (type, listener) {
      eventemitter.on(type, listener)
    }
    this.$emit = function (...args) {
      eventemitter.emit(...args)
    }
    this.$off = function (...args) {
      eventemitter.off(...args)
    }

    this.beforeInit(params)
    this.init(params)
    this.afterInit(params)
    this.data(params)
    this.computed(params)
    this.watch(params)
    this.methods(params)
    let afterBeforeMounted = () => {
      this.mounted(params)
      this.afterMounted(params)
    }
    let beforeHookReturn = this.beforeMounted(params, afterBeforeMounted)
    if (beforeHookReturn === undefined) {
      afterBeforeMounted()
    }
  }
  _initEventEmitter () {
    return new EventEmitter2({
      //
      // set this to `true` to use wildcards. It defaults to `false`.
      //
      wildcard: true,
      //
      // the delimiter used to segment namespaces, defaults to `.`.
      //
      delimiter: '::',
      //
      // set this to `true` if you want to emit the newListener event. The default value is `true`.
      //
      newListener: false,
      //
      // the maximum amount of listeners that can be assigned to an event, default 10.
      //
      maxListeners: 20,
      //
      // show event name in memory leak message when more than maximum amount of listeners is assigned, default false
      //
      verboseMemoryLeak: false
    })
  }
  beforeInit () {
  }
  init () {
  }
  afterInit () {
  }
  data () {
  }
  computed () {
  }
  methods () {
  }
  watch () {
  }
  beforeMounted () {
  }
  mounted () {
  }
  afterMounted () {
  }
}
export default BaseView



// WEBPACK FOOTER //
// ./src/components/index.js